export default __webpack_public_path__ + "static/media/heartLikeLight.708e329d.svg";